import { Account } from '../model/Account';
import { Company } from '../model/Company';
import { AuthType, Instance } from '../model/Instance';
import { InstanceSettings } from '../model/InstanceSettings';
import { Location } from '../model/Location';
import { Node } from '../model/Node';

export const getNodes = async (instance: Instance, start: number, length: number, orderBy: string, orderAsc: boolean, accountId: string, locationId: string, status: string, search: string): Promise<{ nodes: Node[], total: number, filtered: number, active: number, inactive: number, accounts: number, locations: number }> => {
  let url = `https://${instance.name}.web.app/api/invoicing/node?start=${start}&length=${length}`;
  search && (url += `&search=${search}`);
  accountId && (url += `&accountId=${accountId}`);
  locationId && (url += `&locationId=${locationId}`);
  status && (url += `&status=${status}`);
  orderBy && (url += `&orderBy=${orderBy}&orderAsc=${orderAsc}`);
  console.log('url', url);
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    }
  };
  const response = await fetch(url, options);
  const result = await response.json();
  return result;
}

export const getAccounts = async (instance: Instance): Promise<Account[]> => {
  const url = `https://${instance.name}.web.app/api/account`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    }
  };
  const response = await fetch(url, options);
  const accounts = await response.json();
  return accounts;
}

export const getLocations = async (instance: Instance, accountId?: string): Promise<Location[]> => {
  let url = `https://${instance.name}.web.app/api/location`;
  accountId && (url += `?accountId=${accountId}`);
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    }
  };
  const response = await fetch(url, options);
  const locations = await response.json();
  return locations;
}

export const assignLicense = async (instance: Instance, nodeId: string, licenseId?: string) => {
  const url = `https://${instance.name}.web.app/api/invoicing/license/assign`;
  const body: any = { nodeId };
  licenseId && (body.licenseId = licenseId);
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    },
    body: JSON.stringify(body)
  };
  await fetch(url, options);
}

export const unassignLicense = async (instance: Instance, nodeId: string, licenseId: string) => {
  const url = `https://${instance.name}.web.app/api/invoicing/license/unassign`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    },
    body: JSON.stringify({ nodeId, licenseId })
  };
  await fetch(url, options);
}

export const getSettings = async (instance: Instance): Promise<InstanceSettings> => {
  const url = `https://${instance.name}.web.app/api/invoicing/settings`;
  const options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    }
  };
  const response = await fetch(url, options);
  return await response.json() as InstanceSettings;
}

export const getCompany = async (instance: Instance): Promise<Company> => {
  const url = `https://${instance.name}.web.app/api/invoicing/company`;
  const options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    }
  };
  const response = await fetch(url, options);
  return await response.json() as Company;
}

export const saveCompany = async (instance: Instance, companyInformation: Company): Promise<void> => {
  const url = `https://${instance.name}.web.app/api/invoicing/company`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    },
    body: JSON.stringify(companyInformation)
  };
  await fetch(url, options);
}

export const saveCompanyEmail = async (instance: Instance, email: string, verificationCode: string): Promise<void> => {
  const url = `https://${instance.name}.web.app/api/invoicing/company/email/${email}/${verificationCode}`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    }
  };
  await fetch(url, options);
}

export const checkEmailVerificationCode = async (instance: Instance, code: string): Promise<boolean> => {
  const url = `https://${instance.name}.web.app/api/invoicing/company/check-code/${code}`;
  const options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    }
  };
  const response = await fetch(url, options);
  const json = await response.json();
  return json.valid;
}

export const validateEmail = async (instance: Instance, email: string): Promise<boolean> => {
  const url = `https://${instance.name}.web.app/api/invoicing/company/validate-email/${email}`;
  const options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    }
  };
  const response = await fetch(url, options);
  const json = await response.json();
  return json.valid;
}

export const saveSettings = async (instance: Instance, settings: InstanceSettings) => {
  const url = `https://${instance.name}.web.app/api/invoicing/settings`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${instance.apiKey}`,
      'X-Auth-Type': instance.authType || AuthType.apiKey
    },
    body: JSON.stringify(settings)
  };
  await fetch(url, options);
}